module.exports = __webpack_public_path__ + "img/DJ.aa87450a.svg";